function FillFormPayQuote() {
	var urlParams = new URLSearchParams(window.location.search);
	//const myParam = urlParams.get('myParam');

	var amount = urlParams.get('amount');
	var oppowner = urlParams.get('oppowner');
	var accountname = urlParams.get('accountname');
	var quoteid = urlParams.get('quoteid');
	var oppemail = urlParams.get('oppemail');

	if( amount == null || typeof(+amount) != 'number' ) return false;

	$('.js-input-amount').val( amount );
	$('.js-input-quoted').val( oppowner );
	$('.js-input-account-name').val( accountname );
	$('.js-input-reference').val( quoteid );
	$('.js-input-oppemail').val( oppemail );
	$('.js-original-url').val( location.search );

	$('.js-pq-amount').text( amount );
	$('.js-pq-quoted').text( oppowner );
	$('.js-pq-account-name').text( accountname );
	$('.js-pq-reference').text( quoteid );
}

export { FillFormPayQuote };